import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { useBlockContext } from './BlockContext';

/** @deprecated Use useContracts */
export function useParameterSources(contractData) {
  useContracts(contractData);
}
export function useContracts(contractData) {
  var _useBlockContext = useBlockContext(),
    contractDataSources = _useBlockContext.contractDataSources;
  return React.useMemo(function () {
    var upstreamParamSources = _toConsumableArray(contractDataSources !== null && contractDataSources !== void 0 ? contractDataSources : []);
    if (contractData) {
      upstreamParamSources.push(contractData);
    }
    return upstreamParamSources;
  }, [contractDataSources, contractData]);
}